import {
  Component,
  EventEmitter,
  Output,
  Input,
  TemplateRef,
  ViewChild,
  HostListener
} from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { CommonEnums } from '../../enums/comman.enums';
import { ButtonComponent } from '../button/button.component';
import { CommonModule } from '@angular/common';
import { KEYBOARD_KEYS } from 'src/app/constants/constant';
import { InfoIconComponent } from '../info-icon/info-icon.component';
import { CommonService } from 'src/app/modules/shared/services/common.service';
import { CarouselModule as PCarouselModule } from 'primeng/carousel';

@Component({
  selector: 'app-alert-modal',
  templateUrl: './alert-modal.component.html',
  styleUrls: ['./alert-modal.component.scss'],
  standalone: true,
  imports: [CommonModule, ButtonComponent, InfoIconComponent, PCarouselModule]
})
export class AlertModalComponent {
  @Output() confirmed = new EventEmitter<void>();
  @Output() secondaryConfirmed = new EventEmitter<void>();
  @Output() canceled = new EventEmitter<boolean>();
  @Output() tertiaryBtnEvent = new EventEmitter();
  @Output() showButtonOnHeaderEvent = new EventEmitter();

  @Input() showBackBtn: boolean = false;
  @Input() showModalBreak: boolean = true;
  @Input() headerLabel: string;
  @Input() headerInfoMessage: string;
  @Input() confirmBtnLabel: string | CommonEnums = CommonEnums.OK;
  @Input() cancelBtnLabel: string;
  @Input() secondaryCancelBtnLabel: string;
  @Input() tertiaryBtnLabel: string;
  @Input() secondaryBtnLabel: string;
  @Input() sideLogo: string = '';
  @Input() sideIconClass: string = '';
  @Input() showConfirmationBtn = true;
  @Input() showCrossBtn = true;
  @Input() bodyContent: string = '';
  @Input() cancelButtonClass: string = 'btn btn-default';
  @Input() confirmButtonClass: string = 'btn btn-primary';
  @Input() showCrossBtnInBody = false;
  @Input() closeModalOnSuccess = true;
  @Input() modalOptions = {};
  @Input() disableConfirmButton: boolean = false;
  @Input() confirmBtnLoading: boolean = false;
  @Input() dynamicClass = '';
  @Input() sideInfoMessage = '';
  @Input() confirmBtnPrefixIconPath = null;
  @Input() isDeleteModal = false;
  @Input() closeModalOnEsc = true;
  @Input() saveOnEnter = false;
  @Input() subHeader: string;
  @Input() restrictedContentImagerc: string;
  @Input() showButtonOnHeader: any = {
    showButton: false,
    label: 'Download CSV',
    buttonIcon: '',
    buttonClick: () => {
      this.showButtonOnHeaderEvent.emit();
    },
    class: 'btn btn-primary'
  };
  @Input() notShowConfirmBtn: boolean = true;

  @ViewChild('customModalTemplate', { static: true })
  customModalTemplate: TemplateRef<any>;
  modalRef: BsModalRef;
  isSuccess = false;
  isModalOpen = false;
  currentCarouselIndex: number = 0;

  constructor(
    private modalService: BsModalService,
    private cs: CommonService
  ) { }

  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (this.isModalOpen && this.cs.isBrowser) {
      if (event.key === KEYBOARD_KEYS.ESCAPE && this.closeModalOnEsc) {
        this.closeModal();
      }
      if (event.key === KEYBOARD_KEYS.ENTER && this.saveOnEnter) {
        this.confirm();
      }
    }
  }
  openModal() {
    this.modalRef = this.modalService.show(
      this.customModalTemplate,
      this.modalOptions
    );
    this.isModalOpen = true;
    this.modalRef?.onHide.subscribe(() => {
      this.isModalOpen = false;
      this.cancel(this.showBackBtn ? null : this.isSuccess);
    });
  }

  closeModal() {
    this.isSuccess = null;
    this.modalRef?.hide();
  }

  confirm() {
    this.isSuccess = true;
    this.confirmed.emit();
    if (this.closeModalOnSuccess) this.closeModal();
  }
  secondaryBtnClicked() {
    this.secondaryConfirmed.emit();

  }

  onCarouselPageChange(event: { page: number }) {
    this.currentCarouselIndex = event.page;
  }
  
  cancel(emitValue?: boolean) {
    this.canceled.emit(this.showBackBtn ? emitValue : this.isSuccess);
    if (!this.showBackBtn) this.closeModal();
  }
}
